"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactComponent = SvgComponent;
exports.default = void 0;

var _pragma = require("../../pragma");

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgComponent(props) {
  return (0, _pragma.createFelaElement)("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), (0, _pragma.createFelaElement)("defs", null), (0, _pragma.createFelaElement)("clipPath", {
    id: "prefix__a"
  }, (0, _pragma.createFelaElement)("path", {
    d: "M0 0h24v24H0z"
  })), (0, _pragma.createFelaElement)("g", {
    clipPath: "url(#prefix__a)"
  }, (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    d: "M12.837 22c3.864 0 6.993-2.122 6.993-5.823 0-1.36-.381-2.422-1.116-3.211s-1.523-1.306-2.367-1.605c-.844-.3-1.96-.626-3.347-.926-2.558-.571-3.891-1.034-4-2.857 0-1.632 1.333-2.476 3.483-2.476s3.429.87 3.537 2.966h3.565c0-1.986-.653-3.483-1.986-4.517C16.293 2.517 14.633 2 12.592 2 8.673 2 5.517 4.068 5.517 7.85c0 2.531 1.497 4.028 3.238 4.762.898.354 1.932.68 3.157.98 1.088.245 1.904.462 2.421.626s.98.408 1.36.762c.409.353.6.816.6 1.415 0 1.55-1.551 2.585-3.483 2.585-2.286 0-4.164-1.306-4.273-3.946H5C5 19.605 8.755 22 12.837 22z"
  })));
}

var _default = 'src/asset/icon/securities.icon.svg';
exports.default = _default;
//# sourceMappingURL=securities.icon.js.map